import React, { useEffect, useState, useRef } from "react";

import axios from "axios";
import Header from "../Header";
import Footer from "../Footer";
import { calculatePrice } from "../../utils/utils";
import { getApiErrorText } from "../../utils/apiResponse";
import { refreshBasketAvailability } from "../../utils/basketAvailability";
import { prepareCheckoutProducts } from '../../utils/orderAvailability';
import { validateAll } from "indicative";
import "../../styles/common.css";
import {Tooltip, OverlayTrigger} from "react-bootstrap";

import { useBasketStore } from '../../store/Basket';
import NovaPostCityInput from '../new/NovaPostCityInput';
import NovaPostDepartmentInput from '../new/NovaPostDepartmentInput';
import NovaPostAddressInput from '../new/NovaPostAddressInput';
import { fetchReceiveMethods } from '../../utils/apiUtils';
import { defineOrderStatusClassName, renderOrderStatusAdminLabel, getOrderStatusMainLabel, RECEIVE_METHOD_PICKUP_ID } from '../../utils/adminOrderService';
import { useHistory } from 'react-router-dom';
import CheckoutProductList from './CheckoutProductList';
import ukraineFlag from '../../assets/images/ua.svg';
import AdminDiscountForm from '../new/AdminDiscountForm';
import {
  buildApplyDiscountQuery,
  calcPercentDiscountedPrice,
  parseDiscountPercent,
  resolveDiscountUserIdentity,
} from '../../utils/adminDiscount';

import useCheckoutPromo from '../../hooks/useCheckoutPromo';
import PromoCodeInput from '../promo/PromoCodeInput';
import { fetchPromoWheel } from '../../api/promoCodesApi';

const createCheckoutRequestId = () => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

const CheckoutPage = props => {
  const products = useBasketStore(state => state.products);
  const clearBasket = useBasketStore(state => state.clearBasket);

  let [token, setToken] = useState("");
  let [userId, setUserId] = useState(null);
  // Додати до замовлення: пошук замовлення (як у прикріпленні оплат)
  const [availableOrders, setAvailableOrders] = useState([]);
  const [orderSearchQuery, setOrderSearchQuery] = useState('');
  const [showOrderDropdown, setShowOrderDropdown] = useState(false);
  const [addToOrderSelectedOrderId, setAddToOrderSelectedOrderId] = useState(null);
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [orderSearchTimeout, setOrderSearchTimeout] = useState(null);
  let [selectedUserId, setSelectedUserId] = useState(null);
  const [attachUserSearchQuery, setAttachUserSearchQuery] = useState('');
  const [attachUserSelectedUser, setAttachUserSelectedUser] = useState(null);
  const [showAttachUserDropdown, setShowAttachUserDropdown] = useState(false);
  const [availableAttachUsers, setAvailableAttachUsers] = useState([]);
  const [isLoadingAttachUsers, setIsLoadingAttachUsers] = useState(false);
  const [attachUserSearchTimeout, setAttachUserSearchTimeout] = useState(null);
  const attachUserDropdownRef = useRef(null);
  let [user, setUser] = useState(null);
  let [name, setName] = useState("");
  let [surname, setSurname] = useState("");
  const [departmentNumber, setDepartmentNumber] = useState("");
  const [novaPostAddressRef, setNovaPostAddressRef] = useState("");

  let [city, setCity] = useState(null);
  const [novaPostDeliveryCityRef, setNovaPostDeliveryCityRef] = useState(""); //uses to search streets
  const [novaPostCityRef, setNovaPostCityRef] = useState("");
  const [street, setStreet] = useState(null);
  const [novaPostStreetRef, setNovaPostStreetRef] = useState("");
  const [buildingNumber, setBuildingNumber] = useState(null);
  const [flatNumber, setFlatNumber] = useState(null);
  let [phone, setPhone] = useState("");
  let [payment, setPayment] = useState("CREDIT_CARD");
  let [userComment, setUserComment] = useState("");
  let [doNotCall, setDoNotCall] = useState(true);
  let [errorMessage, setErrorMessage] = useState("");
  let [checkLength, setCheckLength] = useState(false);
  let [disabled, setDisabled] = useState(false);
  // Окремі повідомлення для різних адмін-блоків
  const [discountMessage, setDiscountMessage] = useState("");
  const [discountErrorMessage, setDiscountErrorMessage] = useState("");
  const [addToOrderMessage, setAddToOrderMessage] = useState("");
  const [addToOrderErrorMessage, setAddToOrderErrorMessage] = useState("");
  const [attachUserMessage, setAttachUserMessage] = useState("");
  const [attachUserErrorMessage, setAttachUserErrorMessage] = useState("");
  let [discountPercent, setDiscountPercent] = useState("");
  const [discountUserSearchQuery, setDiscountUserSearchQuery] = useState("");
  const [discountSelectedUser, setDiscountSelectedUser] = useState(null);
  const [discountLevelsList, setDiscountLevelsList] = useState([]);
  const [selectedDiscountLevel, setSelectedDiscountLevel] = useState("");
  let [isPromOrder, setIsPromOrder] = useState(false);
  let [forceDiscount, setForceDiscount] = useState(false);
  const [showCommentInput, setShowCommentInput] = useState(false);
  const [showAdminAttachUserModal, setShowAdminAttachUserModal] = useState(false);
  const [attachUserModalError, setAttachUserModalError] = useState('');
  const [attachModalPhoneLookupLoading, setAttachModalPhoneLookupLoading] = useState(false);
  const [attachModalNoMatchForOrderPhone, setAttachModalNoMatchForOrderPhone] = useState(false);

  const [receiveMethods, setReceiveMethods] = useState([]);
  const [selectedReceiveMethod, setSelectedReceiveMethod] = useState(null);
  const [checkoutSubmitError, setCheckoutSubmitError] = useState('');
  const [expectedArrivalDateMismatchProducts, setExpectedArrivalDateMismatchProducts] = useState([]);
  const [deliveryAddresses, setDeliveryAddresses] = useState([]);
  const [selectedDeliveryAddressId, setSelectedDeliveryAddressId] = useState('');
  const [deliveryAddressDropdownOpen, setDeliveryAddressDropdownOpen] = useState(false);
  const [deliveryAddressSearchText, setDeliveryAddressSearchText] = useState('');
  const [showAddressSearchField, setShowAddressSearchField] = useState(false); // один раз при першому завантаженні: якщо адрес >10 — показуємо пошук і не ховаємо
  const [addressSelectedToastMessage, setAddressSelectedToastMessage] = useState(null);
  const [isLoadingDeliveryAddresses, setIsLoadingDeliveryAddresses] = useState(false);
  const [showAdminFields, setShowAdminFields] = useState(() => typeof window !== 'undefined' && window.innerWidth >= 768);
  const history = useHistory();

  const checkoutRequestId = useRef(null);
  const promo = useCheckoutPromo({ products, userId: user?.type === 'ADMIN' ? selectedUserId : userId, isAdmin: user?.type === 'ADMIN', token });
  useEffect(() => {
    // Admin checkout has no customer until one is selected. An own wheel code
    // identifies a personal purchase, but never overrides an explicit customer.
    if (user?.type !== 'ADMIN' || selectedUserId || !promo.appliedCode.startsWith('SPIN-')) return;
    let cancelled = false;
    fetchPromoWheel().then(state => {
      if (!cancelled && state?.reward?.code === promo.appliedCode) setSelectedUserId(user.id);
    }).catch(() => { /* The promo preview keeps its error and can be retried. */ });
    return () => { cancelled = true; };
  }, [user?.id, user?.type, selectedUserId, promo.appliedCode, token]);

  const ADDRESS_SELECTED_TOAST_DURATION_MS = 2500;
  const DELIVERY_ADDRESSES_LIMIT = 50;

  // Refresh current availability while keeping the customer's requested quantities.
  useEffect(() => {
    if (!products || products.length === 0) {
      setExpectedArrivalDateMismatchProducts([]);
      return;
    }
    let cancelled = false;
    const authToken = localStorage.getItem('token');
    const isCurrent = () => !cancelled && useBasketStore.getState().products === products;
    refreshBasketAvailability(products, async id => {
      const response = await axios.get(`/api/v1/product/${id}`, {
        headers: authToken ? { Authorization: authToken } : {},
      });
      return response.data.data;
    }, isCurrent).then(result => {
      if (!result || !isCurrent()) return;
      // Keep the warning after writing the refreshed dates triggers the next effect.
      setExpectedArrivalDateMismatchProducts(previous => Array.from(new Set([
        ...previous.filter(name => products.some(product => product.name === name)),
        ...result.mismatches,
      ])));
      if (result.changed) useBasketStore.getState().setProducts(result.products);
    });
    return () => { cancelled = true; };
  }, [products]);

  let [errors, setErrors] = useState({
    name: false,
    surname: false,
    city: false,
    phone: false,
    departmentNumber: false,
    street: false,
    buildingNumber: false,
    novaPostStreetRef: false
  });

  let nameRef = useRef();
  let surNameRef = useRef();
  let commentRef = useRef();
  const addToOrderDropdownRef = useRef(null);
  const deliveryAddressDropdownRef = useRef(null);
  const deliveryAddressSearchTimeoutRef = useRef(null);
  const hasSetShowSearchFromLoadRef = useRef(false);


  const loadDeliveryAddresses = (authToken, searchQuery, limit = DELIVERY_ADDRESSES_LIMIT, onSuccess) => {
    if (!authToken) return;
    setIsLoadingDeliveryAddresses(true);
    const params = new URLSearchParams();
    params.append('limit', limit);
    if (searchQuery != null && String(searchQuery).trim() !== '') params.append('search', searchQuery.trim());
    axios
      .get(`/api/v1/user/delivery-addresses?${params.toString()}`, { headers: { Authorization: authToken } })
      .then((res) => {
        const list = res.data?.data ?? [];
        const arr = Array.isArray(list) ? list : [];
        setDeliveryAddresses(arr);
        if (typeof onSuccess === 'function') onSuccess(arr);
      })
      .catch(() => {
        setDeliveryAddresses([]);
        if (typeof onSuccess === 'function') onSuccess([]);
      })
      .finally(() => setIsLoadingDeliveryAddresses(false));
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);
    if (storedToken) {
      axios
        .get("/api/v1/auth/current-user", {
          headers: {
            Authorization: storedToken
          }
        })
        .then(function(res) {
          const user = res.data.data;
          setUser(user);
          // Встановлюємо userId тільки якщо це не адмін (для адміна userId встановлюється через модалку)
          if (user.type !== 'ADMIN') {
            setUserId(user.id);
          }
        }).catch(function (error) {
        });
    }

    fetchReceiveMethods(storedToken, setReceiveMethods);
  }, []);

  // Адреси: пошук завжди на бекенді. Показати поле пошуку чи ні — один раз при першому відповіді (якщо адрес >10).
  useEffect(() => {
    if (!token) return;
    const searchTrimmed = (deliveryAddressSearchText || '').trim();
    const onFirstLoad = (list) => {
      if (!hasSetShowSearchFromLoadRef.current) {
        hasSetShowSearchFromLoadRef.current = true;
        setShowAddressSearchField(list.length > 10);
      }
    };

    if (deliveryAddressSearchTimeoutRef.current) clearTimeout(deliveryAddressSearchTimeoutRef.current);

    if (searchTrimmed === '') {
      loadDeliveryAddresses(token, '', DELIVERY_ADDRESSES_LIMIT, onFirstLoad);
    } else {
      deliveryAddressSearchTimeoutRef.current = setTimeout(() => {
        loadDeliveryAddresses(token, deliveryAddressSearchText, DELIVERY_ADDRESSES_LIMIT);
        deliveryAddressSearchTimeoutRef.current = null;
      }, 400);
    }
    return () => {
      if (deliveryAddressSearchTimeoutRef.current) clearTimeout(deliveryAddressSearchTimeoutRef.current);
    };
  }, [token, deliveryAddressSearchText]);

  useEffect(() => {
    if (user?.type === 'ADMIN' && token) {
      axios.get('/api/v1/user/discount-level', { headers: { Authorization: token } })
        .then(res => {
          const data = res.data?.data;
          setDiscountLevelsList(Array.isArray(data) ? data : []);
        })
        .catch(() => setDiscountLevelsList([]));
    }
  }, [user?.type, token]);

  useEffect(() => {
    return () => {
      if (orderSearchTimeout) clearTimeout(orderSearchTimeout);
    };
  }, [orderSearchTimeout]);

  useEffect(() => {
    return () => { if (attachUserSearchTimeout) clearTimeout(attachUserSearchTimeout); };
  }, [attachUserSearchTimeout]);

  /** Нормалізує рядок до 10 цифр у форматі 0XXXXXXXXX (Україна). При +38/38 — обрізає префікс. */
  const normalizePhoneDigits = (raw) => {
    let digits = (raw ?? '').replace(/\D/g, '');
    if (digits.startsWith('38')) digits = digits.slice(2);
    digits = digits.slice(0, 10);
    if (digits.length === 9 && digits[0] !== '0') digits = '0' + digits;
    return digits;
  };

  /** Формат відображення: (0XX) XXX-XX-XX */
  const formatPhoneDisplay = (digits) => {
    if (!digits) return '';
    const d = digits.replace(/\D/g, '').slice(0, 10);
    if (d.length <= 3) return d.length ? `(${d}` : '';
    if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    if (d.length <= 8) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 8)}-${d.slice(8, 10)}`;
  };

  const onChangePhone = (e) => {
    const normalized = normalizePhoneDigits(e.target.value);
    setPhone(normalized);
    setErrors(prev => ({ ...prev, phone: normalized.length > 0 && !/^0\d{9}$/.test(normalized) }));
  };

  const onPhonePaste = (e) => {
    const text = e.clipboardData?.getData?.('text') ?? '';
    const normalized = normalizePhoneDigits(text);
    if (normalized) {
      setPhone(normalized);
      setErrors(prev => ({ ...prev, phone: !/^0\d{9}$/.test(normalized) }));
      e.preventDefault();
    }
  };

  const onChangePayment = e => {
    setPayment(e.target.value);
  };

  const handleDoNotCallCheckbox = () => {
    setDoNotCall(!doNotCall);
  }

  const buildCheckoutRequestData = (options = {}) => {
    const { adminUserIdOverride, forceAdminWithoutUser } = options;
    const { totalPrice, discountedPrice } = calculatePrice({ products });
    if (!checkoutRequestId.current) checkoutRequestId.current = createCheckoutRequestId();
    const requestData = {
      checkoutRequestId: checkoutRequestId.current,
      promoCode: promo.quote?.promoCode || null,
      expectedPromoTotal: promo.quote?.finalTotal ?? null,
      receiveMethodId: selectedReceiveMethod.id,
      name: name,
      surname: surname,
      city: city || null,
      phone: phone,
      totalPrice: totalPrice,
      discountedPrice: discountedPrice,
      products: prepareCheckoutProducts(products, user?.type === 'ADMIN'),
      departmentNumber: departmentNumber || null,
      payment: payment,
      userComment: userComment || null,
      doNotCall: doNotCall,
      novaPostCityRef: novaPostCityRef || null,
      novaPostAddressRef: novaPostAddressRef || null,
      street: street || null,
      novaPostStreetRef: novaPostStreetRef || null,
      buildingNumber: buildingNumber || null,
      flatNumber: flatNumber || null
    };
    if (user !== undefined && user !== null && user.type === 'ADMIN') {
      if (!forceAdminWithoutUser) {
        const uid =
          adminUserIdOverride !== undefined && adminUserIdOverride !== null
            ? adminUserIdOverride
            : selectedUserId;
        if (uid) {
          requestData.userId = uid;
        }
      }
    } else if (userId) {
      requestData.userId = userId;
    }
    return requestData;
  };

  const submitProcessOrder = (options = {}) => {
    if (promo.blocked || promo.busy) {
      setDisabled(false); setShowAdminAttachUserModal(false);
      setCheckoutSubmitError('Перевірте промокод або приберіть його перед оформленням'); return;
    }
    const intendedUserId = user?.type === 'ADMIN'
      ? (options.forceAdminWithoutUser ? null : options.adminUserIdOverride ?? selectedUserId)
      : userId;
    if (promo.appliedCode && intendedUserId !== promo.quotedUserId) {
      setDisabled(false); setShowAdminAttachUserModal(false);
      setCheckoutSubmitError('Покупця змінено. Перевірте оновлену суму з промокодом і підтвердьте замовлення ще раз.');
      return;
    }
    setDisabled(true);
    setCheckoutSubmitError('');
    const requestData = buildCheckoutRequestData(options);
    axios
      .post(user?.type === 'ADMIN' ? '/api/v1/order/admin-process' : '/api/v1/order/process', requestData, {
        headers: {
          Authorization: token
        }
      })
      .then(function (res) {
        clearBasket();
        const processOrderResponse = res.data.data;
        setDisabled(false);
        setShowAdminAttachUserModal(false);
        setAttachUserModalError('');
        history.push(`/order/confirmation/${processOrderResponse.orderAccessToken}`);
      })
      .catch(function (error) {
        setCheckoutSubmitError(getApiErrorText(error, 'Не вдалося оформити замовлення. Перевірте доступну кількість товарів і спробуйте ще раз.'));
        setDisabled(false);
      });
  };

  useEffect(() => {
    if (!showAdminAttachUserModal) return;
    const onKey = (e) => {
      if (e.key === 'Escape' && !disabled) {
        setShowAdminAttachUserModal(false);
        setAttachUserModalError('');
        setAttachModalPhoneLookupLoading(false);
        setAttachModalNoMatchForOrderPhone(false);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [showAdminAttachUserModal, disabled]);

  /** При відкритті модалки — пошук користувача за телефоном з форми замовлення. */
  useEffect(() => {
    if (!showAdminAttachUserModal) {
      setAttachModalPhoneLookupLoading(false);
      setAttachModalNoMatchForOrderPhone(false);
      return;
    }
    setAttachUserModalError('');
    setAttachUserSelectedUser(null);
    setAttachUserSearchQuery('');
    setShowAttachUserDropdown(false);
    setAvailableAttachUsers([]);

    const phoneOk = phone && /^0\d{9}$/.test(phone);
    if (!phoneOk) {
      setAttachModalNoMatchForOrderPhone(true);
      setAttachModalPhoneLookupLoading(false);
      return;
    }

    const authToken = token || localStorage.getItem('token');
    if (!authToken) {
      setAttachModalNoMatchForOrderPhone(true);
      return;
    }

    const normPhone9 = (p) => {
      let d = String(p ?? '').replace(/\D/g, '');
      if (d.startsWith('380')) d = d.slice(3);
      else if (d.startsWith('38')) d = d.slice(2);
      else if (d.startsWith('0')) d = d.slice(1);
      return d.slice(-9);
    };
    const target9 = normPhone9(phone);

    setAttachModalPhoneLookupLoading(true);
    setAttachModalNoMatchForOrderPhone(false);

    axios
      .get('/api/v1/user?idOrPhoneOrEmail=' + encodeURIComponent(phone.trim()), {
        headers: { Authorization: authToken }
      })
      .then((res) => {
        const list = Array.isArray(res.data?.data) ? res.data.data : [];
        const exact = list.find((u) => normPhone9(u.phoneNumber) === target9);
        const chosen = exact || (list.length === 1 ? list[0] : null);
        if (chosen) {
          setAttachUserSelectedUser(chosen);
          setAttachModalNoMatchForOrderPhone(false);
        } else {
          setAttachModalNoMatchForOrderPhone(true);
          setAttachUserSearchQuery(phone.trim());
        }
      })
      .catch(() => {
        setAttachModalNoMatchForOrderPhone(true);
        setAttachUserSearchQuery(phone.trim());
      })
      .finally(() => setAttachModalPhoneLookupLoading(false));
  }, [showAdminAttachUserModal, phone, token]);

  const handleAdminAttachModalSkip = () => {
    setAttachUserModalError('');
    setShowAdminAttachUserModal(false);
    submitProcessOrder({ forceAdminWithoutUser: true });
  };

  const handleAdminAttachModalConfirm = () => {
    if (!attachUserSelectedUser) {
      setAttachUserModalError('Оберіть користувача зі списку пошуку');
      return;
    }
    const uid = attachUserSelectedUser.id;
    setAttachUserModalError('');
    setSelectedUserId(uid);
    setAttachUserSearchQuery('');
    setShowAttachUserDropdown(false);
    setAttachUserMessage(`Користувача ID ${uid} успішно прикріплено до замовлення`);
    setAttachUserErrorMessage('');
    setShowAdminAttachUserModal(false);
    submitProcessOrder({ adminUserIdOverride: uid });
  };

  const onDiscountUserSearchQueryChange = (query) => {
    setDiscountSelectedUser(null);
    setDiscountUserSearchQuery(query);
  };

  const onDiscountUserSelect = (user) => {
    setDiscountSelectedUser(user);
    setDiscountUserSearchQuery('');
  };

  const onDiscountUserClear = () => {
    setDiscountSelectedUser(null);
    setDiscountUserSearchQuery('');
  };

  const checkout = e => {
    setDisabled(true);
    e.preventDefault();
    if (promo.blocked || promo.busy) { setDisabled(false); setCheckoutSubmitError('Перевірте промокод або приберіть його перед оформленням'); return; }

    const messages = {
      required: "Заповніть, будь ласка, всі обов'язкові поля",
      "phone.min": "Введіть коректний номер телефону",
      "phone.max": "Введіть коректний номер телефону"
    };

    if (!products || products.length === 0) {
      setErrorMessage("Ваш кошик пустий");
      setDisabled(false);
      setCheckLength(true);
      return;
    }

    if (!selectedReceiveMethod) {
      setErrorMessage("Оберіть спосіб отримання");
      setDisabled(false);
      return;
    }

    let rules = {
      name: "required ",
      surname: "required",
      phone: "required | min:10 | max:10",
    };
    if (selectedReceiveMethod.id === 1) {
      rules = {
        ...rules,
        city: "required ",
        departmentNumber: "required"
      };
    } else if (selectedReceiveMethod.id === 2) {
      rules = {
        ...rules,
        city: "required ",
        street: "required ",
        buildingNumber: "required"
      };
      if (!novaPostStreetRef) {
        setErrorMessage("Оберіть вулицю");
        setErrors({ ...errors, novaPostStreetRef: true });
        setDisabled(false);
        return;
      }
    }

    validateAll(
      { name, surname, phone, city, departmentNumber, street, buildingNumber },
      rules,
      messages
    )
      .then(() => {
        if (errors.phone) {
          setErrorMessage("Введіть номер телефону у коректному форматі, наприклад 0953332211");
          setDisabled(false);
          return;
        }
        const isAdminWithoutCustomer =
          user != null &&
          user.type === 'ADMIN' &&
          !selectedUserId;
        if (isAdminWithoutCustomer) {
          setAttachUserModalError('');
          setShowAdminAttachUserModal(true);
          setDisabled(false);
          return;
        }
        submitProcessOrder({});
      })
      .catch(errors => {
        console.log("errors = ", errors);
        if (!Array.isArray(errors)) { setCheckoutSubmitError(getApiErrorText(errors)); setDisabled(false); return; }
        const formattedErrors = {};
        errors.forEach(error => {
          formattedErrors[error.field] = true;
        });
        setErrors(formattedErrors);
        setErrorMessage(errors[0].message);
        setCheckLength(true);
        setDisabled(false);
      });
  };

  const setDiscount = () => {
    setDisabled(true);
    const userIdentity = resolveDiscountUserIdentity(discountSelectedUser, discountUserSearchQuery);
    if (discountPercent === "" && userIdentity === "" && selectedDiscountLevel === "") {
      setDiscountMessage("");
      setDiscountErrorMessage("Введіть знижку у відсотках, оберіть клієнта або рівень знижки");
      setDisabled(false);
      return;
    }
    if (discountPercent !== "") {
      const parsed = parseDiscountPercent(discountPercent);
      if (!parsed.ok) {
        setDisabled(false);
        setDiscountErrorMessage("Знижка повинна бути в діапазоні від 0 до 100");
        setDiscountPercent("");
        return;
      }
      const productsWithDiscount = products.map(product =>
        applyDiscount(product, parsed.percent)
      );
      useBasketStore.getState().setProducts(productsWithDiscount);

      setDiscountMessage("Встановлено знижку " + parsed.percent + "%");
      setDiscountErrorMessage("");
      setDiscountUserSearchQuery("");
      setDiscountSelectedUser(null);
      setDiscountPercent("");
      setSelectedDiscountLevel("");
      setDisabled(false);
      return;
    }

    let headers = {};
    if (token) {
      headers = { Authorization: token };
    }

    const appliedLevel = selectedDiscountLevel; // рівень, який відправили на бекенд
    const query = buildApplyDiscountQuery({
      discountLevel: selectedDiscountLevel,
      userIdentity,
    });
    const productsPayload = products.map((product) => ({
      ...product,
      discountedPrice: forceDiscount ? null : product.discountedPrice,
    }));

    axios
      .post('/api/v1/user/apply-discount?' + query, productsPayload, { headers })
      .then(function(res) {
        setDisabled(false);
        const levelForMessage = appliedLevel !== ''
          ? appliedLevel
          : (res.data.data?.discountInfoDto?.level != null ? res.data.data.discountInfoDto.level : null);
        const levelMsg = levelForMessage != null
          ? 'Враховано ' + levelForMessage + ' рівень знижки. '
          : '';
        setDiscountMessage(levelMsg + 'Вартість товарів успішно перерахована.');
        setDiscountUserSearchQuery("");
        setDiscountSelectedUser(null);
        setDiscountPercent("");
        setSelectedDiscountLevel("");
        setDiscountErrorMessage("");
        useBasketStore.getState().setProducts(res.data.data.products);
      })
      .catch(function(error) {
        setDiscountErrorMessage(error.response?.data?.errorMessage || 'Помилка застосування знижки');
        setDiscountMessage("");
        setDisabled(false);
      });
  };

  const handlePromCommissionChange = (index, value) => {
    useBasketStore.setState(state => {
      const updatedProducts = [...state.products];
      updatedProducts[index] = { ...updatedProducts[index], promCommission: value };
      return { products: updatedProducts };
    });
  };

  const applyDiscount = (product, discount) => {
    const discountedPrice = calcPercentDiscountedPrice(
      product.price,
      product.discountedPrice,
      discount,
      forceDiscount
    );
    return { ...product, discountedPrice };
  };

  const formatAddToOrderCurrency = (amount) => {
    if (!amount) return '0 грн';
    return parseFloat(amount).toLocaleString('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' грн';
  };

  const formatOrderDisplay = (order) => {
    const orderId = order.orderId || order.id;
    const surname = order.userInfo?.surname || '';
    const price = order.discountedPrice ?? order.price ?? 0;
    return `#${orderId}${surname ? ` - ${surname}` : ''} - ${formatAddToOrderCurrency(price)}`;
  };

  const filterOrders = (orders, query) => {
    if (!query || query.trim() === '') return orders;
    const lowerQuery = query.toLowerCase();
    return orders.filter(order => {
      const orderId = (order.orderId || order.id || '').toString();
      const surname = (order.userInfo?.surname || '').toLowerCase();
      const price = (order.discountedPrice ?? order.price ?? 0).toString();
      return orderId.includes(lowerQuery) || surname.includes(lowerQuery) || price.includes(lowerQuery);
    });
  };

  const loadAvailableOrders = (searchQuery = '') => {
    setIsLoadingOrders(true);
    const authToken = token || localStorage.getItem('token');
    let url = '/api/v1/order?numberPerPage=50&page=1';
    const trimmed = searchQuery.trim();
    const isNumeric = /^\d+$/.test(trimmed);
    if (isNumeric && trimmed) {
      url += '&orderId=' + encodeURIComponent(trimmed);
    } else if (!isNumeric && trimmed) {
      url += '&clientSurname=' + encodeURIComponent(trimmed);
    }
    axios.get(url, { headers: { Authorization: authToken } })
      .then(res => {
        if (res.status === 200 && res.data.data) {
          setAvailableOrders(res.data.data);
        }
      })
      .catch(() => setAvailableOrders([]))
      .finally(() => setIsLoadingOrders(false));
  };

  const addProductsToOrder = () => {
    setDisabled(true);
    if (!addToOrderSelectedOrderId) {
      setAddToOrderErrorMessage("Виберіть замовлення");
      setAddToOrderMessage("");
      setDisabled(false);
      return;
    }

    const targetOrderId = String(addToOrderSelectedOrderId);
    let headers = {};
    if (token) {
      headers = { Authorization: token };
    }

    axios
      .post('/api/v1/order/add-products?targetOrderId=' + targetOrderId,
          prepareCheckoutProducts(products, user?.type === 'ADMIN'),
        { headers }
      )
      .then(function(res) {
        setDisabled(false);
        clearBasket();
        setAddToOrderSelectedOrderId(null);
        setOrderSearchQuery('');
        setShowOrderDropdown(false);
        setAvailableOrders([]);
        setAddToOrderMessage('Товари було успішно додано до замовлення');
        setAddToOrderErrorMessage('');
      })
      .catch(function(error) {
        setAddToOrderErrorMessage(getApiErrorText(error, 'Помилка додавання товарів до замовлення'));
        setDisabled(false);
    });
  };

  const formatAttachUserDisplay = (u) => {
    if (!u) return '';
    const fullName = [u.surname, u.name].filter((x) => x && String(x).trim()).join(' ').trim();
    const parts = [u.id];
    if (fullName) parts.push(fullName);
    if (u.phoneNumber) parts.push(u.phoneNumber);
    if (u.emailAddress) parts.push(u.emailAddress);
    return parts.join(' · ');
  };

  const loadAttachUsers = (query) => {
    if (!query || query.trim().length < 2) {
      setAvailableAttachUsers([]);
      return;
    }
    setIsLoadingAttachUsers(true);
    const authToken = token || localStorage.getItem('token');
    axios.get('/api/v1/user?idOrPhoneOrEmail=' + encodeURIComponent(query.trim()), { headers: { Authorization: authToken } })
      .then(res => {
        if (res.status === 200 && res.data.data) setAvailableAttachUsers(Array.isArray(res.data.data) ? res.data.data : []);
        else setAvailableAttachUsers([]);
      })
      .catch(() => setAvailableAttachUsers([]))
      .finally(() => setIsLoadingAttachUsers(false));
  };

  const applyAttachUser = () => {
    if (!attachUserSelectedUser) {
      setAttachUserErrorMessage('Оберіть користувача для прив\'язки');
      setAttachUserMessage('');
      return;
    }
    setSelectedUserId(attachUserSelectedUser.id);
    setAttachUserSearchQuery('');
    setShowAttachUserDropdown(false);
    setAttachUserMessage(`Користувача ID ${attachUserSelectedUser.id} успішно прикріплено до замовлення`);
    setAttachUserErrorMessage('');
  };

  const clearAttachUser = () => {
    setSelectedUserId(null);
    setAttachUserSelectedUser(null);
    setAttachUserSearchQuery('');
    setShowAttachUserDropdown(false);
    setAvailableAttachUsers([]);
    setAttachUserMessage('');
    setAttachUserErrorMessage('');
  };

  const handleReceiveMethodChange = (event) => {
    const selectedValue = parseInt(event.target.value);
    const selectedMethod = receiveMethods.find(method => method.id === selectedValue);
    setSelectedReceiveMethod(selectedMethod);
    if (payment === 'CASH' && selectedValue !== RECEIVE_METHOD_PICKUP_ID) {
      setPayment('CREDIT_CARD');
    }
    if (selectedMethod) {
      if (selectedValue === 1) {
        setEmptyAddress();
      } else if (selectedValue === 2) {
        setEmptyCityAndDepartmentNumber();
      } else if (selectedValue === RECEIVE_METHOD_PICKUP_ID) {
        setEmptyCityAndDepartmentNumber();
        setEmptyAddress();
      }
    }
  };

  const setEmptyCityAndDepartmentNumber = () => {
    setCity('');
    setNovaPostCityRef('');
    setNovaPostDeliveryCityRef('');
    setDepartmentNumber('');
    setNovaPostAddressRef('');
  }

  const setEmptyAddress = () => {
    setStreet('');
    setNovaPostStreetRef('');
    setBuildingNumber('');
    setFlatNumber('');
  };

  const clearDeliveryFields = () => {
    setCheckLength(false);
    setErrors(prev => ({
      ...prev,
      name: false,
      surname: false,
      city: false,
      phone: false,
      departmentNumber: false,
      street: false,
      buildingNumber: false,
      novaPostStreetRef: false
    }));
    setName('');
    setSurname('');
    setPhone('');
    setSelectedReceiveMethod(null);
    setCity('');
    setNovaPostCityRef('');
    setNovaPostDeliveryCityRef('');
    setDepartmentNumber('');
    setNovaPostAddressRef('');
    setStreet('');
    setNovaPostStreetRef('');
    setBuildingNumber('');
    setFlatNumber('');
  };

  const applyDeliveryAddress = (addr) => {
    setSelectedDeliveryAddressId(String(addr.id));
    setDeliveryAddressDropdownOpen(false);
    setDeliveryAddressSearchText('');
    setName(addr.name ?? '');
    setSurname(addr.surname ?? '');
    const rawPhone = (addr.phone ?? '').replace(/\D/g, '');
    setPhone(rawPhone.length >= 10 ? rawPhone.slice(-10) : rawPhone);
    const methodId = addr.receiveMethod?.id;
    if (methodId && receiveMethods.length) {
      const method = receiveMethods.find((m) => m.id === methodId);
      if (method) setSelectedReceiveMethod(method);
    }
    setCity(addr.city ?? '');
    setNovaPostCityRef(addr.novaPostCityRef ?? '');
    setNovaPostDeliveryCityRef('');
    setDepartmentNumber(addr.departmentNumber ?? '');
    setNovaPostAddressRef(addr.novaPostAddressRef ?? '');
    setStreet(addr.street ?? '');
    setNovaPostStreetRef(addr.novaPostStreetRef ?? '');
    setBuildingNumber(addr.buildingNumber ?? '');
    setFlatNumber(addr.flatNumber ?? '');
    setAddressSelectedToastMessage('Дані доставки заповнено з обраної адреси');
    setTimeout(() => setAddressSelectedToastMessage(null), ADDRESS_SELECTED_TOAST_DURATION_MS);
  };

  const selectNewAddress = () => {
    clearDeliveryFields();
    setSelectedDeliveryAddressId('');
    setDeliveryAddressDropdownOpen(false);
    setDeliveryAddressSearchText('');
  };

  useEffect(() => {
    if (!deliveryAddressDropdownOpen) return;
    const handleClickOutside = (e) => {
      if (deliveryAddressDropdownRef.current && !deliveryAddressDropdownRef.current.contains(e.target)) {
        setDeliveryAddressDropdownOpen(false);
        setDeliveryAddressSearchText('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [deliveryAddressDropdownOpen]);

  const formatDeliveryAddressLabel = (addr) => {
    const namePart = [addr.name, addr.surname].filter(Boolean).join(' ');
    const phonePart = (addr.phone || '').replace(/\D/g, '');
    const phoneDisplay = phonePart.length >= 9 ? '0' + phonePart.slice(-9) : addr.phone || '';
    const cityRaw = addr.city || '';
    const cityPart = cityRaw.includes(',') ? cityRaw.split(',')[0].trim() : cityRaw;
    const lastPart = addr.departmentNumber || addr.street || '';
    const parts = [namePart, phoneDisplay, cityPart, lastPart].filter(Boolean);
    return parts.length ? parts.join(', ') : `Адреса #${addr.id}`;
  };

  // Пошук адрес тепер на бекенді (параметр search у API)

  const doNotCallTooltip = (
      <Tooltip id="tooltip">
        <strong>Замовлення буде відправлено автоматично без додаткового дзвінка. Якщо обрано спосіб оплати "за реквізитами на картку" - реквізити будуть відправлені в SMS.</strong>
      </Tooltip>
  );

  const renderPromCommissionBlock = (index) => {
    if (showAdminFields && user !== undefined && user !== null && user.type === 'ADMIN' && isPromOrder) {
      return (
        <div className='row'>
          <div className='col-6'>
            <input
              type='text'
              className='form-control'
              name={`promCommission_${index}`}
              placeholder='Комісія прому'
              onChange={(e) => handlePromCommissionChange(index, e.target.value)}
              value={products[index].promCommission ?? ''}
              aria-label={`Комісія прому: ${products[index].name}`}
            />
          </div>
        </div>
      );
    }
  };

  const renderDiscountBlock = () => {
    if (user !== undefined && user !== null && user.type === 'ADMIN') {
      return (
        <div className="pt-3">
          <h6 className="font-weight-bold mb-1">Застосувати знижку до всього замовлення:</h6>
          <AdminDiscountForm
            forceDiscount={forceDiscount}
            onForceDiscountChange={() => setForceDiscount(!forceDiscount)}
            discountLevelsList={discountLevelsList}
            selectedDiscountLevel={selectedDiscountLevel}
            onDiscountLevelChange={(e) => setSelectedDiscountLevel(e.target.value)}
            discountPercent={discountPercent}
            onDiscountPercentChange={(e) => setDiscountPercent(e.target.value)}
            token={token}
            selectedUser={discountSelectedUser}
            userSearchQuery={discountUserSearchQuery}
            onUserSearchQueryChange={onDiscountUserSearchQueryChange}
            onUserSelect={onDiscountUserSelect}
            onUserClear={onDiscountUserClear}
            disabled={disabled}
            forceCheckboxId="forceDiscountCheckbox"
            forceCheckClassName="checkout-discount-form-check"
            onApply={setDiscount}
          />
          {discountMessage !== undefined && discountMessage !== "" && (
            <div className="mt-2 alert alert-success text-center pt-2 mb-0" role="alert">
              {discountMessage}
            </div>
          )}
          {discountErrorMessage !== undefined && discountErrorMessage !== "" && (
            <div className="mt-2 alert alert-danger text-center pt-2 mb-0" role="alert">
              {discountErrorMessage}
            </div>
          )}
        </div>
      )
    }
  };

  const renderAddToOrderBlock = () => {
    if (user === undefined || user === null || user.type !== 'ADMIN') return null;

    const selectedOrder = addToOrderSelectedOrderId
      ? availableOrders.find(o => (o.orderId || o.id) === parseInt(addToOrderSelectedOrderId))
      : null;
    const filteredOrders = filterOrders(availableOrders, orderSearchQuery);

    return (
        <div className="pt-3" ref={addToOrderDropdownRef}>
        <h6 className="font-weight-bold mb-1">Додати до замовлення:</h6>
        {promo.appliedCode && <p className="small text-muted mb-2">Промокод кошика діє для нового замовлення. Для наявного використовується його власний промокод; змінити його можна в деталях замовлення.</p>}
        <div className="row align-items-end">
          <div className="col-12 col-md-8 mb-1 mb-md-0 position-relative">
            <div className="position-relative w-100">
              <input
                type="text"
                className="form-control"
                value={selectedOrder ? formatOrderDisplay(selectedOrder) : orderSearchQuery}
                onChange={(e) => {
                  const value = e.target.value;
                  setOrderSearchQuery(value);
                  setShowOrderDropdown(true);
                  if (addToOrderSelectedOrderId) setAddToOrderSelectedOrderId(null);
                  if (orderSearchTimeout) clearTimeout(orderSearchTimeout);
                  const timeoutId = setTimeout(() => loadAvailableOrders(value), 300);
                  setOrderSearchTimeout(timeoutId);
                }}
                onFocus={() => {
                  setShowOrderDropdown(true);
                  if (availableOrders.length === 0) loadAvailableOrders(orderSearchQuery);
                }}
                onBlur={() => {
                  // Закриваємо дропдаун при втраті фокусу, якщо клік був поза списком
                  setShowOrderDropdown(false);
                }}
                placeholder="Введіть ID замовлення, прізвище або суму"
              />
              {(addToOrderSelectedOrderId || orderSearchQuery) && (
                <span
                  className="position-absolute"
                  style={{
                    right: 10,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '1.2rem',
                    color: '#6c757d',
                    zIndex: 10,
                  }}
                  onClick={() => {
                    setAddToOrderSelectedOrderId(null);
                    setOrderSearchQuery('');
                    setShowOrderDropdown(false);
                    setAvailableOrders([]);
                  }}
                >
                  ×
                </span>
              )}
            </div>
            {showOrderDropdown && (
              <div
                className="position-absolute w-100 bg-white border rounded shadow-lg checkout-dropdown-mobile-fullwidth"
                style={{
                  zIndex: 10000,
                  maxHeight: '300px',
                  overflowY: 'auto',
                  top: '100%',
                  marginTop: 2,
                }}
                onMouseDown={(e) => {
                  // Не даємо інпуту втратити фокус при кліку по елементу списку
                  e.preventDefault();
                }}
              >
                {isLoadingOrders ? (
                  <div className="p-3 text-center">Завантаження...</div>
                ) : filteredOrders.length > 0 ? (
                  filteredOrders.map((order) => {
                    const orderId = order.orderId || order.id;
                    return (
                      <div
                        key={orderId}
                        onMouseDown={(e) => {
                          // Вибираємо замовлення до того, як інпут втратить фокус
                          e.preventDefault();
                          setAddToOrderSelectedOrderId(String(orderId));
                          setOrderSearchQuery('');
                          setShowOrderDropdown(false);
                        }}
                        style={{
                          padding: 10,
                          cursor: 'pointer',
                          borderBottom: '1px solid #dee2e6',
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f8f9fa'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'white'; }}
                      >
                        <div className="row no-gutters" style={{ fontSize: '0.875rem' }}>
                          <div className="col-12">
                            <span className="font-weight-bold">#{orderId}</span>
                            {order.userInfo?.surname && <span className="ml-2">{order.userInfo.surname}</span>}
                            {order.userInfo?.name && <span className="ml-1">{order.userInfo.name}</span>}
                          </div>
                          {order.orderStatus && (
                            <div className="col-12 text-right mt-1">
                              <span
                                className={`${defineOrderStatusClassName(order.orderStatus)}`}
                                style={{ fontSize: '0.65rem', padding: '0.15rem 0.35rem', whiteSpace: 'normal', textAlign: 'right' }}
                              >
                                {getOrderStatusMainLabel(order.orderStatus)}
                              </span>
                              {renderOrderStatusAdminLabel(order.orderStatus) && (
                                <div className="mt-1 d-inline-block text-right" style={{ maxWidth: '100%' }}>
                                  {renderOrderStatusAdminLabel(order.orderStatus)}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <div style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                          Сума: {formatAddToOrderCurrency(order.discountedPrice ?? order.price ?? 0)}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="p-3 text-center text-muted">
                    {orderSearchQuery ? 'Нічого не знайдено' : 'Введіть запит для пошуку замовлень'}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="col-12 col-md-4 mt-1 mt-md-0">
            <button
              type="button"
              className="btn btn-dark btn-block d-none d-md-block"
              onClick={addProductsToOrder}
              disabled={disabled || !addToOrderSelectedOrderId}
            >
              Додати
            </button>
            <button
              type="button"
              className="btn btn-dark btn-sm btn-block d-md-none"
              onClick={addProductsToOrder}
              disabled={disabled || !addToOrderSelectedOrderId}
            >
              Додати
            </button>
          </div>
        </div>
        {addToOrderMessage && (
          <div className="mt-2 alert alert-success text-center pt-2" role="alert">
            {addToOrderMessage}
          </div>
        )}
        {addToOrderErrorMessage && (
          <div className="mt-2 alert alert-danger text-center pt-2" role="alert">
            {addToOrderErrorMessage}
          </div>
        )}
      </div>
    );
  };

  /** Поле пошуку + випадайка користувача; у модалці без бокових кнопок «Прикріпити». */
  const renderAttachUserPickControls = (includeSideButtons, forModal) => {
    const displayValue = selectedUserId
      ? `Прикріплено: ID ${selectedUserId}`
      : (attachUserSelectedUser ? formatAttachUserDisplay(attachUserSelectedUser) : attachUserSearchQuery);
    const hasSelectionOrQuery = selectedUserId || attachUserSelectedUser || attachUserSearchQuery;
    const dropdownClass = forModal
      ? 'position-absolute w-100 bg-white border rounded shadow-sm'
      : 'position-absolute w-100 bg-white border rounded shadow-lg checkout-dropdown-mobile-fullwidth';

    return (
      <div className="row align-items-end">
        <div className={`col-12 ${includeSideButtons ? 'col-md-8' : ''} mb-1 mb-md-0 position-relative`}>
          <div className="position-relative w-100">
            <input
              type="text"
              className="form-control"
              value={displayValue}
              onChange={(e) => {
                const value = e.target.value;
                if (selectedUserId) return;
                setAttachUserSearchQuery(value);
                setAttachUserSelectedUser(null);
                setShowAttachUserDropdown(true);
                if (attachUserSearchTimeout) clearTimeout(attachUserSearchTimeout);
                const timeoutId = setTimeout(() => loadAttachUsers(value), 300);
                setAttachUserSearchTimeout(timeoutId);
              }}
              onFocus={() => {
                if (selectedUserId) return;
                setShowAttachUserDropdown(true);
                if (attachUserSearchQuery.trim().length >= 2 && availableAttachUsers.length === 0) loadAttachUsers(attachUserSearchQuery);
              }}
              onBlur={() => {
                setShowAttachUserDropdown(false);
              }}
              placeholder="Введіть ID, телефон, email або прізвище (мін. 2 символи)"
              readOnly={!!selectedUserId}
            />
            {hasSelectionOrQuery && (
              <span
                className="position-absolute"
                style={{ right: 10, top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', fontSize: '1.2rem', color: '#6c757d', zIndex: 10 }}
                onClick={clearAttachUser}
              >
                ×
              </span>
            )}
          </div>
          {showAttachUserDropdown && !selectedUserId && (
            <div
              className={dropdownClass}
              style={{ zIndex: forModal ? 10050 : 10000, maxHeight: '300px', overflowY: 'auto', top: '100%', marginTop: 2 }}
              onMouseDown={(e) => {
                e.preventDefault();
              }}
            >
              {isLoadingAttachUsers ? (
                <div className="p-3 text-center">Завантаження...</div>
              ) : availableAttachUsers.length > 0 ? (
                availableAttachUsers.map((u) => (
                  <div
                    key={u.id}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      setAttachUserSelectedUser(u);
                      setAttachUserSearchQuery('');
                      setShowAttachUserDropdown(false);
                    }}
                    style={{ padding: 10, cursor: 'pointer', borderBottom: '1px solid #dee2e6' }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f8f9fa'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'white'; }}
                  >
                    <div style={{ fontSize: '0.875rem' }}>{formatAttachUserDisplay(u)}</div>
                  </div>
                ))
              ) : (
                <div className="p-3 text-center text-muted">
                  {attachUserSearchQuery.trim().length >= 2 ? 'Нічого не знайдено' : 'Введіть мін. 2 символи'}
                </div>
              )}
            </div>
          )}
        </div>
        {includeSideButtons && (
          <div className="col-12 col-md-4 mt-1 mt-md-0">
            {selectedUserId ? (
              <>
                <button
                  type="button"
                  className="btn btn-dark btn-block d-none d-md-block"
                  onClick={clearAttachUser}
                >
                  Скасувати
                </button>
                <button
                  type="button"
                  className="btn btn-dark btn-sm btn-block d-md-none mt-1 mt-md-0"
                  onClick={clearAttachUser}
                >
                  Скасувати
                </button>
              </>
            ) : (
              <>
                <button
                  type="button"
                  className="btn btn-dark btn-block d-none d-md-block"
                  onClick={applyAttachUser}
                  disabled={!attachUserSelectedUser}
                >
                  Прикріпити
                </button>
                <button
                  type="button"
                  className="btn btn-dark btn-sm btn-block d-md-none"
                  onClick={applyAttachUser}
                  disabled={!attachUserSelectedUser}
                >
                  Прикріпити
                </button>
              </>
            )}
          </div>
        )}
      </div>
    );
  };

  const renderAttachUserBlock = () => {
    if (user === undefined || user === null || user.type !== 'ADMIN') return null;

    return (
      <div className="pt-3" ref={attachUserDropdownRef}>
        <h6 className="font-weight-bold mb-1">Прикріпити до користувача:</h6>
        {renderAttachUserPickControls(true, false)}
        {attachUserMessage && (
          <div className="mt-2 alert alert-success text-center pt-2" role="alert">
            {attachUserMessage}
          </div>
        )}
        {attachUserErrorMessage && (
          <div className="mt-2 alert alert-danger text-center pt-2" role="alert">
            {attachUserErrorMessage}
          </div>
        )}
      </div>
    );
  };

    return (
      <div className="container checkout-page">
        {checkoutSubmitError && <div className="alert alert-danger" role="alert">{checkoutSubmitError}</div>}
        <style>{`
          @media (max-width: 767.98px) {
            .checkout-dropdown-mobile-fullwidth {
              width: 100vw !important;
              max-width: 100vw !important;
              left: 50% !important;
              margin-left: -50vw !important;
              box-sizing: border-box;
            }
          }
          .checkout-admin-attach-plaque {
            border-radius: 10px;
            overflow: hidden;
            border: 1px solid #c5e4cd;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
            background: #fff;
          }
          .checkout-admin-attach-plaque-head {
            display: flex;
            align-items: center;
            gap: 0.65rem;
            padding: 0.6rem 1rem;
            background: linear-gradient(180deg, #ecf7ef 0%, #e2f2e7 100%);
            border-bottom: 1px solid #c8e6d0;
          }
          .checkout-admin-attach-plaque-badge {
            flex-shrink: 0;
            width: 1.65rem;
            height: 1.65rem;
            border-radius: 50%;
            background: #28a745;
            color: #fff;
            font-size: 0.8rem;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;
            box-shadow: 0 1px 4px rgba(40, 167, 69, 0.35);
          }
          .checkout-admin-attach-plaque-label {
            font-size: 1rem;
            font-weight: 700;
            color: #18692a;
            line-height: 1.35;
          }
          .checkout-admin-attach-plaque-value {
            padding: 0.85rem 1rem 1rem calc(1rem + 1.65rem + 0.65rem);
            font-size: 1rem;
            font-weight: 400;
            color: #212529;
            line-height: 1.45;
            background: #fff;
            word-break: break-word;
          }
          .checkout-admin-attach-modal-secondary {
            font-size: 0.8125rem;
          }
          .checkout-admin-attach-modal-secondary h6 {
            font-size: 0.7rem;
            letter-spacing: 0.02em;
            margin-bottom: 0.35rem;
          }
          .checkout-admin-attach-modal-secondary .form-control,
          .checkout-admin-attach-modal-secondary .btn {
            font-size: 0.8125rem;
            padding: 0.25rem 0.5rem;
            min-height: calc(1.5em + 0.5rem + 2px);
          }
        `}</style>
        <div className="row">
          <div className="col p-0">
            <Header />
          </div>
        </div>
        <div className="pt-3 text-center">
        </div>

        <div className="row">
          <div className="col-md-5 order-md-2 mb-2">
            {user !== undefined && user !== null && user.type === 'ADMIN' && (
              <div className="form-check mb-1 checkout-admin-form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="showAdminFieldsCheckbox"
                  checked={showAdminFields}
                  onChange={() => setShowAdminFields(!showAdminFields)}
                />
                <label className="form-check-label font-weight-bold" htmlFor="showAdminFieldsCheckbox">
                  Відображати адмін поля
                </label>
              </div>
            )}
            {showAdminFields && user !== undefined && user !== null && user.type === 'ADMIN' && (
              <div className="form-check mb-2 checkout-admin-form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isPromOrderCheckbox"
                  checked={isPromOrder}
                  onChange={() => setIsPromOrder(!isPromOrder)}
                />
                <label className="form-check-label font-weight-bold" htmlFor="isPromOrderCheckbox">
                  Пром замовлення
                </label>
              </div>
            )}
            <div className="card checkout-products-card">
              <div className="card-header d-flex align-items-center">
                <span className="font-weight-bold">Список товарів</span>
                <span className="badge badge-secondary badge-pill ml-2">{products.length}</span>
              </div>
              <div className="card-body p-0">
            {expectedArrivalDateMismatchProducts.length > 0 && (
              <div className="alert alert-info mb-0 mx-3 mt-3" role="alert">
                <strong>Увага:</strong> Дата надходження змінилась для товарів: {expectedArrivalDateMismatchProducts.join(', ')}.
                Зверніть увагу на актуальну дату надходження в кошику.
              </div>
            )}

              <CheckoutProductList
                products={products}
                promoQuote={promo.quote}
                renderPromoInput={() => <PromoCodeInput promo={promo} disabled={disabled || Boolean(token && !user)}
                  needsRefresh={Boolean(checkoutSubmitError)} onRefresh={() => { setCheckoutSubmitError(''); promo.apply(); }} />}
                renderPromCommissionBlock={renderPromCommissionBlock}
                showAvailability={user?.type === 'ADMIN'}
                forceExpanded={showAdminFields && user?.type === 'ADMIN' && isPromOrder}
              />
              </div>
            </div>
            <div className="d-none d-md-block">
              {showAdminFields && renderDiscountBlock()}
              {showAdminFields && renderAddToOrderBlock()}
              {showAdminFields && renderAttachUserBlock()}
            </div>
          </div>

          <div className="col-md-7 order-md-1 checkout-delivery-form checkout-delivery-block">
            <span className="font-weight-bold checkout-delivery-title d-block mb-2">Вкажіть дані для доставки:</span>
            {token && (
              <div className="form-group mb-3 checkout-existing-address-block" ref={deliveryAddressDropdownRef}>
                <label>Вибрати з існуючих адрес</label>
                <div className="position-relative">
                  <button
                    type="button"
                    className="form-control checkout-address-select-btn d-flex align-items-center text-left bg-white border"
                    style={{ minHeight: 40 }}
                    onClick={() => setDeliveryAddressDropdownOpen(prev => !prev)}
                    aria-expanded={deliveryAddressDropdownOpen}
                    aria-haspopup="listbox"
                  >
                    {selectedDeliveryAddressId ? (
                      <span className="checkout-address-button-text">
                        {(() => {
                          const addr = deliveryAddresses.find(a => String(a.id) === String(selectedDeliveryAddressId));
                          return addr ? formatDeliveryAddressLabel(addr) : 'Обрати адресу';
                        })()}
                      </span>
                    ) : (
                      <span className="text-muted">Обрати адресу</span>
                    )}
                    <i
                      className="bi bi-chevron-down ml-auto flex-shrink-0"
                      style={{ transition: 'transform 0.2s', transform: deliveryAddressDropdownOpen ? 'rotate(180deg)' : 'none' }}
                    />
                  </button>
                  {deliveryAddressDropdownOpen && (
                    <div
                      className="checkout-address-dropdown border rounded shadow-sm bg-white position-absolute w-100 mt-1"
                      style={{ zIndex: 1050, maxHeight: 280, overflowY: 'auto' }}
                      role="listbox"
                    >
                      {showAddressSearchField && (
                        <div className="p-2 border-bottom" onClick={(e) => e.stopPropagation()}>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Пошук за адресою..."
                            value={deliveryAddressSearchText}
                            onChange={(e) => setDeliveryAddressSearchText(e.target.value)}
                            autoFocus
                          />
                          {isLoadingDeliveryAddresses && (
                            <small className="text-muted">Завантаження...</small>
                          )}
                        </div>
                      )}
                      {selectedDeliveryAddressId && (
                        <div
                          className="p-2 d-flex align-items-center border-bottom"
                          style={{ cursor: 'pointer' }}
                          onMouseEnter={(e) => e.currentTarget.classList.add('bg-light')}
                          onMouseLeave={(e) => e.currentTarget.classList.remove('bg-light')}
                          onClick={selectNewAddress}
                          role="option"
                        >
                          <span className="text-muted">Очистити і ввести нову адресу</span>
                        </div>
                      )}
                      {deliveryAddresses.length === 0 ? (
                        <div className="p-2 text-center font-weight-bold">
                          {deliveryAddressSearchText
                            ? 'Такої адреси не знайдено.'
                            : 'Немає збережених адрес.'}
                        </div>
                      ) : (
                        deliveryAddresses.map((addr) => (
                          <div
                            key={addr.id}
                            className="p-2 d-flex align-items-center border-bottom"
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={(e) => e.currentTarget.classList.add('bg-light')}
                            onMouseLeave={(e) => e.currentTarget.classList.remove('bg-light')}
                            onClick={() => applyDeliveryAddress(addr)}
                            role="option"
                          >
                            <span className="checkout-address-option-text">{formatDeliveryAddressLabel(addr)}</span>
                          </div>
                        ))
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className='row'>
              <div className='col-md-6 mb-3'>
                <label htmlFor='name'>Ім'я</label>
                <input
                  ref={nameRef}
                  type='text'
                  className={!errors.name || (checkLength && name && name.length > 0) ? 'form-control' : 'form-control form-input-fail'}
                  name='name'
                  placeholder="Введіть ім'я отримувача"
                  onChange={() => setName(nameRef.current.value)}
                  value={name || ''}
                />
              </div>

              <div className='col-md-6 mb-3'>
                <label htmlFor='surname'>Прізвище</label>
                <input
                  ref={surNameRef}
                  type='text'
                  className={!errors.surname || (checkLength && surname && surname.length > 0) ? 'form-control' : 'form-control form-input-fail'}
                  name='surname'
                  placeholder='Введіть прізвище отримувача'
                  onChange={() => setSurname(surNameRef.current.value)}
                  value={surname || ''}
                />
              </div>
            </div>

            <div className='mb-1'>
              <label htmlFor='phone'>Номер телефону</label>
              <div className='space-between'>
                <img
                  className='flag'
                  src={ukraineFlag}
                  alt="Ukraine flag"
                />
                <p className="country_code px-1">+38</p>
                <input
                  type="tel"
                  inputMode="numeric"
                  autoComplete="tel"
                  id="phone"
                  name="phone"
                  className={
                    !errors.phone
                      ? "form-control"
                      : "form-control form-input-fail"
                  }
                  placeholder="Введіть номер телефону"
                  value={formatPhoneDisplay(phone)}
                  onChange={onChangePhone}
                  onPaste={onPhonePaste}
                />
              </div>
            </div>

            <div className='form-check mb-3' style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  className='form-check-input mt-0'
                  type='checkbox'
                  onChange={handleDoNotCallCheckbox}
                  id='doNotCallCheckbox'
                  defaultChecked={true}
                  style={{ width: '1rem', height: '1rem' }}
                />
              </div>
              <label className='form-check-label ml-1 mr-1' htmlFor='doNotCallCheckbox'
                     style={{ flexGrow: 1, fontSize: '0.9rem' }}>
                Не телефонувати для підтвердження замовлення
                <OverlayTrigger placement='top' overlay={doNotCallTooltip}>
                  <i className='bi bi-info-circle px-1' />
                </OverlayTrigger>
              </label>
            </div>

            <div className='form-group mb-3'>
              <label htmlFor='receiveMethod'>Спосіб отримання</label>
              <select
                className='form-control'
                id='receiveMethod'
                onChange={handleReceiveMethodChange}
                value={selectedReceiveMethod ? selectedReceiveMethod.id : ''}
              >
                {!selectedReceiveMethod && (
                  <option value='' disabled hidden>
                    Оберіть спосіб отримання
                  </option>
                )}
                {receiveMethods.map(method => (
                  <option key={method.id} value={method.id}>
                    {method.description}
                  </option>
                ))}
              </select>
            </div>

            {selectedReceiveMethod && (
              <div>

                {selectedReceiveMethod.id !== RECEIVE_METHOD_PICKUP_ID && (
                  <NovaPostCityInput
                    value={city}
                    onCityChange={(suggestion) => {
                      setCity(suggestion.present);
                      setNovaPostCityRef(suggestion.ref);
                      setNovaPostDeliveryCityRef(suggestion.deliveryCity);
                    }}
                    inputClassName={!errors.city || (checkLength && city && city.length > 0) ? 'form-control' : 'form-control form-input-fail'}
                  />
                )}

                {selectedReceiveMethod.id === 1 && (
                  <NovaPostDepartmentInput
                    value={departmentNumber}
                    onDepartmentChange={(suggestion) => {
                      setDepartmentNumber(suggestion.description);
                      setNovaPostAddressRef(suggestion.ref);
                    }}
                    novaPostCityRef={novaPostCityRef}
                    novaPostDeliveryCityRef={novaPostDeliveryCityRef}
                    cityName={city}
                  />
                )}

                {selectedReceiveMethod.id === 2 && (
                  <NovaPostAddressInput
                    street={street}
                    buildingNumber={buildingNumber}
                    flatNumber={flatNumber}
                    onStreetChange={(suggestion) => {
                      setStreet(suggestion.street);
                      setNovaPostStreetRef(suggestion.ref);
                    }}
                    onBuildingNumberChange={(buildingNumber) => {
                      setBuildingNumber(buildingNumber);
                    }}
                    onFlatNumberChange={(flatNumber) => {
                      setFlatNumber(flatNumber);
                    }}
                    novaPostCityRef={novaPostCityRef}
                    novaPostDeliveryCityRef={novaPostDeliveryCityRef}
                    cityName={city}
                    streetInputClassName={(!errors.street && !errors.novaPostStreetRef) || (checkLength && novaPostStreetRef && novaPostStreetRef.length > 0) ? 'form-control' : 'form-control form-input-fail'}
                    buildingNumberInputClassName={!errors.buildingNumber || (checkLength && buildingNumber && buildingNumber.length > 0) ? 'form-control' : 'form-control form-input-fail'}
                  />
                )}
              </div>
            )}

            <div className='checkout-order-comment pl-2'>
              <span
                className='font-weight-bold cursor-pointer'
                onClick={() => setShowCommentInput(!showCommentInput)}
              >
                <i
                  className='bi bi-chat-square-text pr-1' />{!showCommentInput ? 'Додати коментар' : 'Залиште коментар нижче:'}
              </span>

              {showCommentInput && (
                <div className='pt-1'>
                  <textarea
                    ref={commentRef}
                    name='comment'
                    className='form-control'
                    placeholder='За необхідності залиште коментар до замовлення'
                    onChange={() => setUserComment(commentRef.current.value)}
                    value={userComment}
                    style={{ height: "100px" }}
                  />
                </div>
              )}
            </div>

            <hr className="mb-4" />
            <span className="font-weight-bold checkout-delivery-title d-block">Оберіть спосіб оплати:</span>
            <div className="d-block my-2">
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="customRadio1"
                  name="customRadio"
                  value="CREDIT_CARD"
                  className="custom-control-input"
                  checked={payment === "CREDIT_CARD"}
                  onChange={onChangePayment}
                />
                <label
                  className="custom-control-label"
                  htmlFor="customRadio1"
                >
                  Карткою за IBAN реквізитами
                </label>
              </div>
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="customRadio2"
                  name="customRadio"
                  value="CASH_ON_DELIVERY"
                  className="custom-control-input"
                  checked={payment === "CASH_ON_DELIVERY"}
                  onChange={onChangePayment}
                />
                <label
                  className="custom-control-label"
                  htmlFor="customRadio2"
                >
                  Оплата після отримання у відділенні
                </label>
              </div>
              {selectedReceiveMethod?.id === RECEIVE_METHOD_PICKUP_ID && (
                <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    id="customRadioCash"
                    name="customRadio"
                    value="CASH"
                    className="custom-control-input"
                    checked={payment === "CASH"}
                    onChange={onChangePayment}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customRadioCash"
                  >
                    Готівкою
                  </label>
                </div>
              )}
            </div>

            {/* Блок адміна на мобайлі: після оплати, перед кнопкою Підтвердити */}
            <div className="d-md-none mt-3 mb-3">
              {showAdminFields && renderDiscountBlock()}
              {showAdminFields && renderAddToOrderBlock()}
              {showAdminFields && renderAttachUserBlock()}
            </div>

            <hr className="mb-4" />
            <button
              className="btn btn-dark btn-lg btn-block"
              type="submit"
              disabled={disabled || promo.blocked || promo.busy}
              onClick={checkout}
            >
              Підтвердити
            </button>
            <div className="form-field-error text-center pt-2 font-weight-bold">
              {errorMessage}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col p-0">
            <Footer />
          </div>
        </div>

        {addressSelectedToastMessage && (
          <div className="family-view-toast" role="alert" aria-live="polite">
            {addressSelectedToastMessage}
          </div>
        )}

        {showAdminAttachUserModal && (
          <div
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.45)',
              zIndex: 11000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '1rem'
            }}
            onClick={() => {
              if (disabled) return;
              setShowAdminAttachUserModal(false);
              setAttachUserModalError('');
              setAttachModalPhoneLookupLoading(false);
              setAttachModalNoMatchForOrderPhone(false);
            }}
            role="presentation"
          >
            <div
              className="shadow bg-white rounded"
              style={{ maxWidth: 520, width: '100%', maxHeight: '90vh', overflow: 'auto', padding: '1.25rem' }}
              onClick={(e) => e.stopPropagation()}
              role="dialog"
              aria-modal="true"
              aria-labelledby="checkout-admin-attach-title"
            >
              <h5 id="checkout-admin-attach-title" className="font-weight-bold mb-3">
                Прикріпити замовлення до користувача?
              </h5>

              {attachModalPhoneLookupLoading && (
                <div className="text-center py-3 text-muted small mb-3">
                  Шукаємо користувача за номером з форми…
                </div>
              )}

              {!attachModalPhoneLookupLoading && attachUserSelectedUser && !attachModalNoMatchForOrderPhone && (
                <div className="checkout-admin-attach-plaque mb-3" role="status">
                  <div className="checkout-admin-attach-plaque-head">
                    <span className="checkout-admin-attach-plaque-badge" aria-hidden="true">
                      ✓
                    </span>
                    <span className="checkout-admin-attach-plaque-label">Знайдено за номером телефону:</span>
                  </div>
                  <div className="checkout-admin-attach-plaque-value">
                    {formatAttachUserDisplay(attachUserSelectedUser)}
                  </div>
                </div>
              )}

              {!attachModalPhoneLookupLoading && attachModalNoMatchForOrderPhone && !attachUserSelectedUser && (
                <div className="alert alert-warning py-2 small mb-3" role="status">
                  За номером <span className="font-weight-medium">{formatPhoneDisplay(phone) || phone}</span> користувача
                  в базі не знайдено. Введіть нижче інший телефон, email або ID (мін. 2 символи) і оберіть зі списку.
                </div>
              )}

              <div className="mb-3 checkout-admin-attach-modal-secondary">
                <h6 className="font-weight-bold mb-2 text-uppercase text-muted">
                  {attachModalNoMatchForOrderPhone ? 'Пошук або інший номер' : 'Інший користувач (за потреби)'}
                </h6>
                {!attachModalPhoneLookupLoading && renderAttachUserPickControls(false, true)}
              </div>
              {attachUserModalError && (
                <div className="alert alert-danger py-2 small mb-3" role="alert">
                  {attachUserModalError}
                </div>
              )}
              <div className="d-flex flex-column flex-sm-row justify-content-stretch justify-content-sm-end flex-wrap" style={{ gap: '0.5rem' }}>
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm order-2 order-sm-1"
                  disabled={disabled}
                  onClick={handleAdminAttachModalSkip}
                >
                  Не прикріплювати
                </button>
                <button
                  type="button"
                  className="btn btn-dark btn-sm order-1 order-sm-2"
                  disabled={disabled || !attachUserSelectedUser}
                  onClick={handleAdminAttachModalConfirm}
                >
                  {disabled ? 'Відправка…' : 'Прикріпити і підтвердити'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
};

export { CheckoutPage };
